import { AccountNs, type DropdownNs, CommonNs } from '@shared/types';
import {customPropertyDropdownOptions, selectableProperties, titleOptions, visibilityOptions} from "@shared/constants";

const skillsOptions = [
  {
    iconType: 'fal',
    icon: 'Globe',
    name: 'Türkçe',
    value: 'Türkçe',
  },
  {
    iconType: 'fal',
    icon: 'Globe',
    name: 'English',
    value: 'English',
  },
  {
    iconType: 'fal',
    icon: 'Globe',
    name: 'Deutsch',
    value: 'Deutsch',
  },
] as DropdownNs.DropdownOptionsItem[];

const profileProperties = [
  ...selectableProperties,
  {
    label: 'Position',
    icon: 'Briefcase',
    iconType: 'fal',
    isFixed: true,
    input: {
      name: AccountNs.PropertyEnums.POSITION,
      type: 'select',
      placeholder: 'Position',
      value: '',
      selectOptions: titleOptions,
    },
    dropdown: {
      name: 'positionPermission',
      options: visibilityOptions,
      value: CommonNs.PermissionsEnums.EVERYONE,
    },
  },
  {
    label: 'Bio',
    icon: 'AlignLeft',
    iconType: 'fal',
    input: {
      name: AccountNs.PropertyEnums.BIO,
      type: 'textarea',
      placeholder: 'Bio',
      value: '',
    },
    dropdown: {
      name: 'bioPermission',
      options: visibilityOptions,
      value: CommonNs.PermissionsEnums.EVERYONE,
    },
  },
  {
    label: 'Skill',
    icon: 'Tags',
    iconType: 'fal',
    input: {
      name: AccountNs.PropertyEnums.SKILL,
      type: 'multiselect',
      placeholder: 'Skill',
      value: '',
      selectOptions: skillsOptions,
    },
    dropdown: {
      name: 'skillPermission',
      options: visibilityOptions,
      value: CommonNs.PermissionsEnums.EVERYONE,
    },
  },
] as CommonNs.InputFormGroup[];

export const profileDropdownProperties = [
  {
    name: 'Location',
    iconType: 'fal',
    icon: 'MapPin',
    subOptions: {
      title: 'LOCATION',
      options: [
        {
          name: 'City',
          iconType: 'fal',
          icon: 'MapPin',
          value: AccountNs.PropertyEnums.CITY,
        },
        {
          name: 'Country',
          iconType: 'fal',
          icon: 'Globe',
          value: AccountNs.PropertyEnums.COUNTRY,
        },
      ],
    },
  },
  {
    name: 'Contact',
    iconType: 'fal',
    icon: 'Contact',
    subOptions: {
      title: 'CONTACT',
      options: [
        {
          name: 'Phone',
          inputName: 'phone',
          inputType: 'text',
          iconType: 'fal',
          icon: 'Phone',
          value: AccountNs.PropertyEnums.PHONE,
        },
        {
          name: 'Mobile',
          inputName: 'mobile',
          inputType: 'text',
          iconType: 'fal',
          icon: 'Smartphone',
          value: AccountNs.PropertyEnums.MOBILE,
        },
        {
          name: 'Email',
          inputName: 'email',
          inputType: 'text',
          iconType: 'fal',
          icon: 'AtSign',
          value: AccountNs.PropertyEnums.EMAIL,
        },
        {
          name: 'Website',
          inputName: 'website',
          inputType: 'text',
          iconType: 'fal',
          icon: 'Link',
          value: AccountNs.PropertyEnums.WEBSITE,
        },
      ],
    },
  },
  {
    name: 'Social Media',
    iconType: 'fal',
    icon: 'Share2',
    subOptions: {
      title: 'SOCIAL MEDIA',
      options: [
        {
          name: 'Linkedin',
          inputName: 'linkedin',
          inputType: 'text',
          iconType: 'fab',
          icon: 'linkedin',
          value: AccountNs.PropertyEnums.LINKEDIN,
        },
        {
          name: 'Facebook',
          inputName: 'facebook',
          inputType: 'text',
          iconType: 'fab',
          icon: 'facebook',
          value: AccountNs.PropertyEnums.FACEBOOK,
        },
        {
          name: 'Instagram',
          inputName: 'instagram',
          inputType: 'text',
          iconType: 'fab',
          icon: 'instagram',
          value: AccountNs.PropertyEnums.INSTAGRAM,
        },
        {
          name: 'Twitter',
          inputName: 'twitter',
          inputType: 'text',
          iconType: 'fab',
          icon: 'twitter',
          value: AccountNs.PropertyEnums.TWITTER,
        },
        {
          name: 'Youtube',
          inputName: 'youtube',
          inputType: 'text',
          iconType: 'fab',
          icon: 'youtube',
          value: AccountNs.PropertyEnums.YOUTUBE,
        },
        {
          name: 'Whatsapp',
          inputName: 'whatsapp',
          inputType: 'text',
          iconType: 'fab',
          icon: 'whatsapp',
          value: AccountNs.PropertyEnums.WHATSAPP,
        },
        {
          name: 'Telegram',
          inputName: 'telegram',
          inputType: 'text',
          iconType: 'fab',
          icon: 'telegram',
          value: AccountNs.PropertyEnums.TELEGRAM,
        },
      ],
    },
  },
  {
    name: 'Consulting',
    icon: 'User',
    iconType: 'fal',
    subOptions: {
      title: 'CONSULTING',
      options: [
        {
          name: 'Bio',
          inputName: 'bio',
          inputType: 'textarea',
          iconType: 'fal',
          icon: 'AlignLeft',
          value: AccountNs.PropertyEnums.BIO,
        },
        {
          name: 'Skill',
          inputName: 'skill',
          inputType: 'multiselect',
          iconType: 'fal',
          icon: 'Tags',
          value: AccountNs.PropertyEnums.SKILL,
        },
        {
          name: 'Language',
          inputName: 'language',
          inputType: 'multiselect',
          iconType: 'fal',
          icon: 'Globe',
          value: AccountNs.PropertyEnums.LANGUAGE,
        },
        {
          name: 'Hourly Rate',
          inputName: 'hourlyRate',
          inputType: 'range',
          iconType: 'fal',
          icon: 'Clock',
          value: AccountNs.PropertyEnums.HOURLY_RATE,
        },
        {
          name: 'Daily Rate',
          inputName: 'dailyRate',
          inputType: 'range',
          iconType: 'fal',
          icon: 'Calendar',
          value: AccountNs.PropertyEnums.DAILY_RATE,
        },
      ],
    },
  },
  {
    hasDivider: true,
  },
  ...customPropertyDropdownOptions,
] as DropdownNs.DropdownOptionsItem[];

export default profileProperties;
